import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

interface State {
  phoneNumber: string | null;
  setPhoneNumber: (phoneNumber: string) => void;
}

// this store is plugged only in checkout
// TODO:implement in other components with phone input
const usePhoneNumberInputStore = create<State>((set) => ({
  phoneNumber: null,
  setPhoneNumber: (phoneNumber) => set({ phoneNumber })
}));

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('PhoneNumberInputStore', usePhoneNumberInputStore);
}

export default usePhoneNumberInputStore;
